import multiApiClient from "./base";

export const webshareApi = {
  //create webshare credential
  createWebshareCredential: (credential) =>
    multiApiClient.post("/proxy/webshare/credentials/", credential),

  //get all webshare credentials
  getWebshareCredentials: () =>
    multiApiClient.get("/proxy/webshare/credentials/"),

  //toggle webshare credential active status
  toggleWebshareCredentialStatus: (id) =>
    multiApiClient.post(`/proxy/webshare/credentials/${id}/toggle-active`),

  deleteWebshareCredential: (id) =>
    multiApiClient.delete(`/proxy/webshare/credentials/${id}`),

  updateWebshareCredential: (id, credential) =>
    multiApiClient.put(`/proxy/webshare/credentials/${id}`, credential),

  testWebshareCredentialKey: (key) =>
    multiApiClient.post("/proxy/webshare/test/", { api_key: key }),

  testStoredWebshareCredential: (id) =>
    multiApiClient.post(`/proxy/webshare/credentials/${id}/test`),

  // Fetch Webshare proxy using active credential
  fetchWebshareProxies: () => multiApiClient.post("/proxy/webshare/fetch/"),
};
